<template>
  <div>
    <h3 v-if="!mostrado" class="title toggle toggle-mas">
      <a class="ver-detalles" @click.prevent="mostrado = !mostrado" href="#"
        >Tus Datos</a
      >
    </h3>
    <h3 v-else class="title toggle toggle-menos">
      <a class="ver-detalles" @click.prevent="mostrado = !mostrado" href="#"
        >Tus Datos</a
      >
    </h3>
    <div v-if="mostrado">
      <DatosResumenConductorHabitual :resumen="resumen" />
      <DatosResumenConductorOcasional
        :resumen="resumen"
        v-if="resumen.conductorOcasional"
      />
      <DatosResumenTomador :resumen="resumen" />
      <DatosResumenPropietario
        v-if="
          !resumen.conductorHab.propietario &&
            (resumen.conductorOcasional == null ||
              !resumen.conductorOcasional.propietario) &&
            !resumen.tomador.propietario
        "
        :resumen="resumen"
      />
      <DatosResumenAseguradora v-if="resumen.aseguradora" :resumen="resumen" />
    </div>
  </div>
</template>

<script>
export default {
  store: ["step"],

  data() {
    return {
      mostrado: false
    };
  },

  props: {
    resumen: {
      type: Object
    }
  }
};
</script>

<style>
.toggle {
  padding: 0.7rem;
}

.toggle-mas:before {
  display: inline-block;
  vertical-align: top;
  content: "";
  margin-right: 1em;
  width: 2em;
  height: 2em;
  background: url(../assets/sprite_icons.png) no-repeat -160px -40px;
  font-size: 1rem;
}

.toggle-menos:before {
  display: inline-block;
  vertical-align: top;
  content: "";
  margin-right: 1em;
  width: 2em;
  height: 2em;
  background: url(../assets/sprite_icons.png) no-repeat -136px -40px;
  font-size: 1rem;
}

.ver-detalles {
  font-size: 1.8rem;
}
</style>
